import ConfirmInvite from './ConfirmInvite';

export default ConfirmInvite;
